import Fetch, { V1, serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE, DEFAULT_POST_RESPONSE } from '@config/constanta';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

const fetchPost = (url, payload) =>
  Fetch.post(url, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

const fetchDelete = (url) =>
  Fetch.delete(url)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

// Get Watchlist members
export const getMfWatchlistMember = () => {
  const query = { page: 1, page_size: 30 };
  return fetchGet(`${V1}mutualfund/fund-bundle/watchlist/`, { query });
};

// Add & Remove MF bundle from Watchlist
export const postMfWatchlist = (id) => fetchPost(`${V1}funds/watchlist/`, { fundbundle_id: id });
export const delMfWatchlist = (id) => fetchDelete(`${V1}funds/watchlist/${id}/`);
